import { FC } from "react";

type MainProps = {
  children?: JSX.Element,
};

export const Container:FC<MainProps> = ({ children }) => {

    return (<main className="main">
        {children}
    </main>)
}
